import { isArray } from 'lodash-es';
import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';

export function useQueryParams<T>() {
  const [searchParams] = useSearchParams();

  return useMemo(() => {
    const result: Record<string, string | string[]> = {};

    searchParams.forEach((value, key) => {
      if (key in result) {
        if (isArray(result[key])) {
          (result[key] as string[]).push(value);
        } else {
          result[key] = [result[key] as string, value];
        }
      } else {
        result[key] = value;
      }
    });

    return result as T;
  }, [searchParams]);
}
